import React, { useState, useEffect } from "react";
import { FaPause, FaPlay, FaArrowLeft, FaArrowRight } from "react-icons/fa";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./styles.css";

import img1 from "./img/banner/1.1.jpg";
import img2 from "./img/banner/2.1.jpg";
import img3 from "./img/banner/3.1.jpg";
import img4 from "./img/banner/4.png";
const images = [
  { src: img1, title: "Adiwasi Pawra dressup style" },
  { src: img2, title: "Adiwasi Pawra kids"},
  { src: img3, title: "Tribal childrens enjoying Holidays" },
  { src: img4, title: "Children's School" },
];

const newsItems = [
  "Works Department Panchayat Samiti Jalgaon J Tender Notice 06/02/2025(chain-link-ps-jalgaon-ja.pdf)",
  "Works Department Panchayat Samiti Jalgaon J Tender Notice 06/02/2025(s-r-ladies-toilet-p-s-jalgaon.pdf)",
  "Works Department Panchayat Samiti Jalgaon J Tender Notice 06/02/2025(chain-link-ps-jalgaon-j.pdf)",
];

const extractPdfDetails = (text) => {
  const match = text.match(/\((.*?)\)/); // Extract text inside ()
  if (match) {
    return {
      displayText: text.replace(match[0], "(PDF)"), // Replace filename with (PDF)
      pdfFileName: match[1], // Extracted PDF file name
    };
  }
  return { displayText: text, pdfFileName: null };
};

const HeroSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(true);

  const settings = {
    infinite: true,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 1700,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  useEffect(() => {
    if (isPlaying) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
      }, 3000);
      return () => clearInterval(interval);
    }
  }, [isPlaying]);

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  return (
    <div className="hero-section">
      {/* Image Slider */}
      <div className="image-slider">
        <img src={images[currentIndex].src} alt="Slider" className="slider-image" />
        <div className="image-title">{images[currentIndex].title}</div>
        <div className="slider-controls">
          <button onClick={prevSlide}><FaArrowLeft /></button>
          <button onClick={() => setIsPlaying(!isPlaying)}>
            {isPlaying ? <FaPause /> : <FaPlay />}
          </button>
          <button onClick={nextSlide}><FaArrowRight /></button>
        </div>
      </div>





    </div>
  );
};

export default HeroSection;
